/**
 * Mirrors the host guard in index.html's deferred service-worker loader.
 * Returns true when the current host should NOT register a service worker
 * (Lovable preview, localhost, or `?sw=off` kill switch).
 */
export function isServiceWorkerBlockedHost(): boolean {
  if (typeof window === 'undefined') return true;
  const h = window.location.hostname;
  const isDevHost =
    h === 'localhost' ||
    h === '127.0.0.1' ||
    h.startsWith('id-preview--') ||
    h.startsWith('preview--') ||
    h === 'lovableproject.com' || h.endsWith('.lovableproject.com') ||
    h === 'lovableproject-dev.com' || h.endsWith('.lovableproject-dev.com') ||
    h === 'beta.lovable.dev' || h.endsWith('.beta.lovable.dev');
  const killSwitch = /[?&]sw=off(&|$)/.test(window.location.search);
  return isDevHost || killSwitch;
}
